/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Event_Group_Index_Oob_MessageInputs */

const en_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected event group index is out of bounds`)
};

const fr_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index du groupe d'evenements selectionne hors limites`)
};

const de_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Index der ausgewählten Ereignisgruppe liegt außerhalb des gültigen Bereichs.`)
};

const it_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'indice del gruppo di eventi selezionato è fuori dai limiti`)
};

const ru_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индекс выбранной группы событий выходит за пределы допустимого диапазона.`)
};

const es_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El índice del grupo de eventos seleccionado está fuera de los límites`)
};

const zh_cn2_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选事件组索引超出范围`)
};

const ja_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベント グループ インデックスは範囲外です`)
};

const hi_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह सूचकांक सीमा से बाहर है`)
};

const pt_pt2_iframe_remote_event_group_index_oob_message = /** @type {(inputs: Iframe_Remote_Event_Group_Index_Oob_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O índice do grupo de eventos selecionado está fora dos limites.`)
};

/**
* | output |
* | --- |
* | "Selected event group index is out of bounds" |
*
* @param {Iframe_Remote_Event_Group_Index_Oob_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_event_group_index_oob_message = /** @type {((inputs?: Iframe_Remote_Event_Group_Index_Oob_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Event_Group_Index_Oob_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "de") return de_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "it") return it_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "ru") return ru_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "es") return es_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "ja") return ja_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "hi") return hi_iframe_remote_event_group_index_oob_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_event_group_index_oob_message(inputs)
	return en_iframe_remote_event_group_index_oob_message(inputs)
});